import script from "./mail.vue?vue&type=script&setup=true&lang=js"
export * from "./mail.vue?vue&type=script&setup=true&lang=js"

import "./mail.vue?vue&type=style&index=0&id=1a29ad88&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a29ad88"]])

export default __exports__